import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateCreateLookupOptionMutation, MutateCreateLookupOptionMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateCreateLookupOption($key: String!, $record: JSON!) {
    lookups {
      create(key: $key, record: $record) {
        _id
      }
    }
  }
`)

export type UseMutateCreateLookupOptionReturn = UseMutationResult<
MutateCreateLookupOptionMutation,
unknown,
MutateCreateLookupOptionMutationVariables
>

const useMutateCreateLookupOption = (): UseMutateCreateLookupOptionReturn => {
  return useGraphMutation(document)
}

export { useMutateCreateLookupOption, document as mutateLookupOptionDocument }
